import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { ProductCodeSetDetail } from "../../Table/TableQueryColumn";

const initialState = {
    data: {
        NdcUpcHri: '',
        GPI14: '',
        Ndc9: '',
        PrdDescAbbr: '',
        totalCount: 0,
        page: 0,
        pageSize: 50,
        sortOrder: "asc",
        columnName: "PrdKey",
        collectionName: "Codeset"
    },
    dataAll: "",
    search: true,
    error: false,
    isSearchClicked: false,
    searchTriggered: true,
    loading: false,
    clear: false,
    showAll: false,
    inputError: {
        NdcUpcHri: false,
        GPI14: false,
        Ndc9: false,
        PrdDescAbbr: false
    }
}

export const getCodeSetDetailsData = createAsyncThunk('data/getCodeSetDetailsData',
    async (data, { rejectWithValue }) => {
        try {
            let queryCodeSetDetails =
                `query GetProductCodeSetDetails{
                    GetProductCodeSetDetails(
                pageNumber:${data.page + 1},
                pageSize:${data.pageSize},
                sortOrder:"${data.sortOrder}",
                columnName:"${data.columnName}",
                collectionName:"Codeset",
                isDownload:false,
                ${data.NdcUpcHri ? `,ndcupchri: "${data.NdcUpcHri}"` : ""}
                ${data.GPI14 ? `,gpi14: "${data.GPI14}"` : ""}
                ${data.Ndc9 ? `,ndc9: "${data.Ndc9}"` : ""}
                ${data.PrdDescAbbr ? `,prddescriptionabbr: "${data.PrdDescAbbr}"` : ""}
                `;

            queryCodeSetDetails += ProductCodeSetDetail

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryCodeSetDetails, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

export const getCodeSetDetailsDownloadAll = createAsyncThunk('data/getCodeSetDetailsDownloadAll',
    async (data, { rejectWithValue }) => {
        try {
            let queryCodeSetDetailAll =
                `query GetProductCodeSetDetails{
                    GetProductCodeSetDetails(
                    collectionName:"Codeset",
                    isDownload:true,
                ${data.NdcUpcHri ? `,ndcupchri: "${data.NdcUpcHri}"` : ""}
                ${data.GPI14 ? `,gpi14: "${data.GPI14}"` : ""}
                ${data.Ndc9 ? `,ndc9: "${data.Ndc9}"` : ""}
                ${data.PrdDescAbbr ? `,prddescriptionabbr: "${data.PrdDescAbbr}"` : ""}
                `;

            queryCodeSetDetailAll += ProductCodeSetDetail

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryCodeSetDetailAll, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const codeSetSlice = createSlice({
    name: 'codeSet',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        },
        showAll: (state, action) => {
            state.showAll = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCodeSetDetailsData.pending, (state) => {
                //state.loading = true;
                state.error = false;
            })
            .addCase(getCodeSetDetailsData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetProductCodeSetDetails.totalCount;
                state.data.tableData = response.data.data.GetProductCodeSetDetails.data;
            })
            .addCase(getCodeSetDetailsData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(getCodeSetDetailsDownloadAll.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getCodeSetDetailsDownloadAll.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.tableData = response.data.data.GetProductCodeSetDetails.data;
            })
            .addCase(getCodeSetDetailsDownloadAll.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }
})

export const { currentData, clearData, updateSearch, searchClicked, clearTable,
    searchTriggered, updateInputError, resetError, resetToaster, showAll } = codeSetSlice.actions;
export default codeSetSlice.reducer